import React, { useState, useEffect } from 'react';
import axios from './axios';
import requests from './requests';
import './Banner.css';

function Banner() {
    const [movie, setMovie] = useState( [] );         //this is gonna be responsible for the random movie selection in the banner
    
    //Async function makes changes into the internal API
    useEffect(() => {
        async function fetchData() {
            const request = await axios.get(requests.fetchNetflixOriginals);
            setMovie(
                request.data.results
                [Math.floor(Math.random() * request.data.results.length - 1)
                ]
            );
            return request;
        }
        fetchData();
    }, []);
    
    

    function truncate(str, n) {
        return str?.length > n ? str.substr(0, n - 1) + '...' : str; 
    }

    return (
      <header className="banner"
            style={{
                backgroundSize: "cover",
                backgroundImage: `url(
                "https://image.tmdb.org/t/p/original/${movie?.backdrop_path}"
                )`,
                backgroundPosition: "center center",
            }}
        >
            {/**We are using header so that when we applu changes to our banner image, it would not affect the contents of div(which contains text) */}
            <div className="banner__contents">
                <h1 className="banner__title">
                    {movie?.title || movie?.name || movie?.original_name}
                    {/*we did this(above thingy) bc in the data we either get title, name or original name. so, it gives us whatever is availaible . It kinda is an if else condition*/}
                </h1>

                <div className="banner__buttons">
                    <button className="banner__button">Play</button>
                    <button className="banner__button">My list</button>
                </div>
                <h1 className="banner__description">
                    {truncate(movie?.overview, 150)}
                </h1>
                  
            </div>
            <div className="banner__fadebottom"></div>
                   
        </header> 
    );
}

export default Banner;
